var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAirplane(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 66,
    viewBox: "0 0 77 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.3627 1.13224C74.741 0.77927 73.9809 0.586357 73.1739 0.576722C72.367 0.567087 71.5475 0.741141 70.8143 1.07793L2.97834 32.1343L2.96432 32.1364C2.18259 32.4983 1.53697 33.0284 1.11564 33.6543C0.694317 34.2802 0.517831 34.9713 0.610288 35.6334C0.702744 36.2955 1.05964 36.8962 1.63222 37.3534C2.2048 37.8107 2.96515 38.1022 3.80944 38.1882L3.88319 38.1947L28.8068 42.4217C29.288 42.4596 29.7878 42.3967 30.2561 42.2391C30.7245 42.0815 31.1451 41.8348 31.476 41.5237L67.0354 8.00522C67.1407 7.89932 67.2695 7.80841 67.4145 7.73768C67.5596 7.66696 67.7179 7.6178 67.8806 7.59301C68.0433 7.56823 68.2071 7.5683 68.3627 7.59324C68.5183 7.61817 68.6625 7.66747 68.7873 7.73832C68.9121 7.80918 69.0149 7.9002 69.0899 8.00618C69.1649 8.11217 69.2105 8.23105 69.2243 8.35604C69.2381 8.48102 69.2197 8.60967 69.1702 8.73462C69.1206 8.85958 69.0409 8.9784 68.9357 9.0843L36.2291 44.2114C35.9258 44.5382 35.7293 44.9122 35.6594 45.296C35.5895 45.6799 35.6486 46.0601 35.8307 46.3989L48.1437 63.3246C48.1572 63.3499 48.1704 63.3726 48.1854 63.3963C48.8836 64.5586 50.3996 65.2227 52.1213 65.0206L52.2965 64.9939C53.1628 64.8658 53.9884 64.5403 54.6661 64.0597C55.3438 63.5791 55.8423 62.9657 56.0966 62.2991L76.6863 4.43005C76.9144 3.80309 76.9107 3.15798 76.6758 2.57272C76.4409 1.98746 75.9848 1.48713 75.3627 1.13224V1.13224Z",
    fill: "url(#paint0_linear_318_832)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_318_832",
    x1: 37.242,
    y1: 5.97808,
    x2: 46.3704,
    y2: 65.8968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C3C4C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplane);
export default __webpack_public_path__ + "static/media/airplane.8e13ca60abacfd52c8d38641d0ee8ede.svg";
export { ForwardRef as ReactComponent };